/* eslint-disable camelcase */
function doubtOnWeb2(doubtData = {}) {
  const data = {
    uid: doubtData.uid,
    timeStamp: doubtData.timestamp,
    attachments: doubtData.attachments,
    tag: doubtData.tag,
    state: doubtData.state,
    subject: doubtData.subject
  };

  return data;
}

function getEntityData(data) {
  return doubtOnWeb2(data);
}

const DoubtData = {
  DoubtOnWeb2: doubtOnWeb2,
  getEntityData
};

export default DoubtData;
